module.exports = __webpack_public_path__ + "img/vertical_3_7_8023.7075e1ed.png";